<template>
    <section>
        <div v-show="showlist">
        <sy-baselist
                ref="list"
                hideAdd
                :filters="filters"
                packUpBtn
                editVue="business/Duty_Edit.vue"
                listUrl="server/business/Duty.ashx?cmd=GetList"
                deleteUrl="server/business/Duty.ashx?cmd=Delete"
                :pageSize="20"
                DelTips="该任务相关的所有汇报将会被同时删除，确定删除吗？"
                :fixWhere="fixWhere"
                @beforeAdd="beforeAdd"
                @searchChange="searchChange"
                @onPackUp="onPackUp"
        >
            <el-table-column prop="FName" label="任务名称" width="150">
            </el-table-column>
            <el-table-column prop="FStartTime" label="开始时间" :formatter="formatDate2" width="180" sortable v-if="showtime">
            </el-table-column>
              <el-table-column prop="FEndTime" label="结束时间" :formatter="formatDate2" width="180" sortable v-if="showtime">
            </el-table-column>
            <el-table-column prop="ReciverName" label="接收者" width="100" sortable>
            </el-table-column>
             <el-table-column prop="FProgress" label="进度(%)" width="100" sortable>
            </el-table-column>
            <el-table-column prop="FStatus" label="状态" :formatter="formatStatus" width="100">
            </el-table-column>
             <el-table-column prop="FAuditStatus" label="审核状态" :formatter="formatAuditStatus" width="120">
            </el-table-column>
            <template scope="props" slot="extendbtn">
                <el-button size="mini" class="el-icon-view el-button el-button--text el-button--mini"  @click="showtrends(props.row)">任务汇报</el-button>
                <el-button size="mini" v-if="showbtn(props.row)" class="el-icon-view el-button el-button--text el-button--mini"  @click="pass(props.row)">审核完成</el-button>
                <el-button size="mini" v-if="showbtn(props.row)"  class="el-icon-view el-button el-button--text el-button--mini"  @click="unpass(props.row)">审核未完成</el-button>
            </template>
        </sy-baselist>
        </div>
            <div v-show="showtrend">
                <el-row>
            <el-col  class="toolbar">
                <el-form>
                    <el-form-item>
                        <el-tag  type="gray">{{joblist.length>0?joblist[0].FName:''}}</el-tag>
                        <a @click="showlists" style="color:#409EFF;margin-left: 20px;cursor:pointer;">&lt; 返回</a>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
            <template v-if="false">
                <el-table ref="table" :data="joblist">
                    <el-table-column prop="FName" label="任务名称" width="250" >
                    </el-table-column>
                    <el-table-column prop="FNo" label="任务编号" width="250" >
                    </el-table-column>
                    <el-table-column prop="ProjectName" label="所属项目名称" width="250" >
                    </el-table-column>
                    <el-table-column prop="ProjectDetailName" label="项目阶段" width="250" >
                    </el-table-column>
                </el-table>
            </template>
        <el-row :gutter="20">
            <el-col :span="24">
                <sy-baselist
                        ref="protrends"
                        :autoSearch="false"
                        title="任务汇报"
                        hideAdd
                        hideOperate
                        :filters="reportsfilters"
                        listUrl="server/business/Duty.ashx?cmd=GetReportList"    
                >
                    <el-table-column prop="ProjectName" label="所属项目名称" width="250" >
                    </el-table-column>
                    <el-table-column prop="ProjectDetailName" label="项目阶段" width="250" >
                    </el-table-column>
                    <el-table-column prop="UserName" label="汇报人"  width="100">
                    </el-table-column>
                    <el-table-column prop="FCreateTime" label="汇报时间" :formatter="formatDate2" width="180">
                    </el-table-column>
                      <el-table-column prop="FProgress" label="进度"  width="100">
                    </el-table-column>
                     <el-table-column prop="FSTDTime" label="标准用时"  width="100">
                    </el-table-column>
                      <el-table-column prop="FUseTime" label="耗时"  width="100">
                    </el-table-column>
                    <el-table-column prop="FNote" label="内容" width="100">
                    </el-table-column>
                </sy-baselist>
            </el-col>
        </el-row>
        </div>
    </section>
</template>

<script>
     import util from '../../common/util'
    import mixin from '../../common/mixin'
    export default {
        mixins: [mixin],
        data(){
            return {
                jobID:0,
                jobRow:{},
                filters: [
                    {type: "string",name:"FName",text:"任务名称", value: null},
                     {type: "select",name:"FReciverId",text:"接收者",valueKey:"FID",
                        data:"server/system/Staff.ashx?cmd=GetStafOptions&FDeptId=0"},
                    {type:"select",name:"FAuditStatus",text:"审核状态",data:[[0,"待审核"], [1,"审核通过"],[2,"审核不通过"]]}
                    
                ],
                reportsfilters:[
                      {type: "date",name:"FCreateTime",text:"汇报时间"},
                     {type: "select",name:"FCreateUserId",text:"汇报人",valueKey:"FID",
                        data:"server/system/Staff.ashx?cmd=GetStafOptions&FDeptId=0"}
                ],
                showlist:true,
                showtrend:false,
                joblist:[],
                fixWhere:'',
                projectId:0,
                showtime:false,
                stageId:0,
                stagePId:0,
                projectdetail:{}
            }
        },
        methods:{
             searchChange(key,val,record){
                if(key=="FProjectId"){
                    let item = this.filters.find((v,i,arr)=>{
                        return v.name=="FProjectDetailId"
                    })
                    if(item){
                        item.data = "server/business/Project.ashx?cmd=GetDetailOptions&FProjectId="+(record.FID?record.FID:-1)
                    }
                }
            },
            showtrends(row){
                this.jobID = row.FID
                this.jobRow =row
                this.showlist=false
                this.showtrend=true
                this.joblist=[]
                this.joblist.push(this.jobRow)
                this.$refs.protrends._search("","FDutyId="+this.jobID)
            },     
            showlists(){ 
             this.showtrend=false
             this.showlist=true
            },
            formatStatus(row){
                let status=""
                switch(row.FStatus){
                    case 0: {status='未开始'; break;}
                    case 1: {status='进行中'; break;}
                    case 2: {status='暂停中'; break;}
                    case 3: {status='已结束'; break;}
                }
                return status
            },
             formatAuditStatus(row){
                let status=""
                switch(row.FAuditStatus){
                    case 0: {status='待审核'; break;}
                    case 1: {status='审核完成'; break;}
                    case 2: {status='审核未完成'; break;}
                }
                return status
            },
            _initProject(projectId,stageId,stagePId,detail){
                if(stageId==0){
                 this.fixWhere = "FProjectId="+projectId;
                }
                else{
                    this.fixWhere = "FProjectId="+projectId+" and FProjectDetailId="+stageId;
                }
                this.projectId=projectId;
                this.stageId = stageId;
                this.stagePId = stagePId;
                this.projectdetail = detail
                this.filters =  [
                    {type: "string",name:"FName",text:"任务名称", value: null},
                     {type: "select",name:"FReciverId",text:"接收者",valueKey:"FID",
                        data:"server/system/Staff.ashx?cmd=GetStafOptions&FDeptId=0"}
                ]
                this.reportsfilters=[
                      {type: "date",name:"FCreateTime",text:"汇报时间"},
                     {type: "select",name:"FCreateUserId",text:"汇报人",valueKey:"FID",
                        data:"server/system/Staff.ashx?cmd=GetStafOptions&FDeptId=0"}
                ]
            },
            beforeAdd(row,r){
                
                if(this.projectId!=0){
                   row.FProjectId=this.projectId
                }
                if(this.stageId!=0){
                    if(this.stagePId!=0){
                       let arr=[]
                      arr.push(this.stagePId)
                      arr.push(this.stageId)
                      row.FProjectDetailId = arr
                    }
                   else{
                    row.FProjectDetailId=this.stageId
                   }
                }  
                row.detail = this.projectdetail
            },
            showbtn(row){
                if(row.FStatus==3&&row.FAuditStatus==0){
                    return true
                }
                return false
            },
            pass(row){
               let url = "server/business/Duty.ashx?cmd=AuditDuty"
                util.get(url,{FID:row.FID,pass:true},this.progressFn,result=>{
                    util.msgSuc("审核成功")
                    this.$refs.list._refrash()
                })
            },
            unpass(row){
                let url = "server/business/Duty.ashx?cmd=AuditDuty"
                util.get(url,{FID:row.FID,pass:false},this.progressFn,result=>{
                    util.msgSuc("审核成功")
                    this.$refs.list._refrash()
                })
            },
            onPackUp(flag){
               this.showtime = !this.showtime
               this.$emit("onPackUp",flag)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/business/Duty1.vue